import React from 'react';
import { WarningOutlineIcon, Text } from 'elmo-elements';
import { VPNSectionStyled } from '../style';

export const VPN_MESSAGE =
  'The Trend Vision One Zero Trust Secure Access agent is required to access the Hub applications';

const VPNSection: React.FC = () => {
  return (
    <VPNSectionStyled className="vpn-section">
      <div className="vpn-section__requirement">
        <WarningOutlineIcon className="vpn-section__requirement--warning-icon" />
        <Text size="rg">{VPN_MESSAGE}</Text>
      </div>
      <div className="empty">&nbsp;</div>
      <div>
        <Text size="sm" className="vpn-section__helper">
          Need access or help? Reach out here{' '}
          <a href="slack://channel?team=E08D4QSQ42C&id=C01S55LCE3G">
            #corporate_it_help_desk
          </a>
        </Text>
      </div>
    </VPNSectionStyled>
  );
};

export default VPNSection;
